import { FormControl, Stack, TextField, Typography } from '@mui/material'
import React from 'react'
import {
  Controller,
  type RegisterOptions,
  useFormContext
} from 'react-hook-form'
import { useEffectOnce } from 'react-use'

import type { StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'

export const DEFAULT_POLL_INTERVAL = 30
export const MINIMUM_POLL_INTERVAL = 15
export const MAXIMUM_POLL_INTERVAL = 60

const inputProps = {
  inputProps: {
    max: MAXIMUM_POLL_INTERVAL,
    min: MINIMUM_POLL_INTERVAL
  }
}

const validationOptions: RegisterOptions = {
  required: true,
  max: MAXIMUM_POLL_INTERVAL,
  min: MINIMUM_POLL_INTERVAL
}

export const PollingIntervalField = () => {
  const { control, formState, getValues, setValue } =
    useFormContext<StatusCheckFormValues>()
  const { errors } = formState
  const errorMessage = errors.pollingIntervalSeconds?.message
  const hasError = Boolean(errorMessage)
  const helperText = hasError ? errorMessage : undefined

  // We expect that a default value of this field for existing records may
  // not be defined. We can ensure a default value is set here such that the
  // applied default value should behave as if the user has entered it, which
  // allows for immediate enablement of the save button.
  useEffectOnce(() => {
    if (getValues().pollingIntervalSeconds) return

    setValue('pollingIntervalSeconds', `${DEFAULT_POLL_INTERVAL}`, {
      shouldDirty: true
    })
  })

  return (
    <FormControl component={Stack} sx={{ rowGap: 2 }}>
      <Typography>How often should we perform this check?</Typography>
      <Controller
        control={control}
        name="pollingIntervalSeconds"
        render={({ field }) => (
          <TextField
            {...field}
            error={hasError}
            helperText={helperText}
            InputProps={inputProps}
            label="Polling Interval (seconds)"
            sx={{ maxWidth: 240 }}
            type="number"
          />
        )}
        rules={validationOptions}
      />
    </FormControl>
  )
}
